import React from 'react';
import PropTypes from 'prop-types';

import InputAutocomplete from './InputAutocomplete';

class MultipleInputAutocomplete extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      editable: this.props.editable === undefined || this.props.editable,
      items: this.props.items || [],
      text: '',
      itemDecorator: this.props.itemDecorator || ((item) => item && item.name),
      textDecorator: this.props.textDecorator || ((item) => item && item.name),
      valueDecorator: this.props.valueDecorator || ((item) => item && item.id),
    };

    this.handleAddItem = this.handleAddItem.bind(this);
    this.handleRemoveItem = this.handleRemoveItem.bind(this);
  }

  handleAddItem(itemToAdd) {
    this.setState(
        (state) => ({
          items: [
            ...state.items.filter((item) => item !== itemToAdd),
            { ...itemToAdd, text: this.state.textDecorator(itemToAdd) },
          ],
          text: '',
        }),
        () => {
          this.props.onChange &&
          this.props.onChange({
            target: {
              name: `${this.props.name}[]`,
              validity: { valid: true },
              value: this.state.items.map((item) =>
                this.state.valueDecorator(item)
              ),
            },
          });
        }
    );
  }

  handleRemoveItem(itemToRemove) {
    this.setState(
        (state) => ({
          items: state.items.filter((item) => item !== itemToRemove),
        }),
        () => {
          this.props.onChange &&
          this.props.onChange({
            target: {
              name: `${this.props.name}[]`,
              validity: { valid: true },
              value: this.state.items.map((item) =>
                this.state.valueDecorator(item)
              ),
            },
          });
        }
    );
  }

  render() {
    return (
      <React.Fragment>
        <input type="hidden" name={`${this.props.name}[]`} value="" />
        <div className="field is-grouped is-grouped-multiline">
          {this.state.items.map((item) => (
            <div key={[item.type, item.id].join('-')} className="control">
              <input
                type="hidden"
                name={`${this.props.name}[]`}
                value={this.state.valueDecorator(item)}
              />
              <div className="tags are-medium has-addons">
                <span className="tag is-white">
                  {this.state.textDecorator(item)}
                </span>
                {this.state.editable && (
                  <a
                    className="tag is-delete"
                    onClick={() => this.handleRemoveItem(item)}
                  />
                )}
              </div>
            </div>
          ))}
        </div>

        {this.state.editable && (
          <InputAutocomplete
            itemDecorator={this.state.itemDecorator}
            onChange={this.handleAddItem}
            resetAfterSelect={true}
            text={this.state.text}
            textDecorator={this.state.textDecorator}
            url={this.props.url}
          />
        )}
      </React.Fragment>
    );
  }
}

MultipleInputAutocomplete.propTypes = {
  onChange: PropTypes.func,
  editable: PropTypes.bool,
  items: PropTypes.arrayOf(PropTypes.object),
  itemDecorator: PropTypes.func,
  name: PropTypes.string,
  textDecorator: PropTypes.func,
  valueDecorator: PropTypes.func,
  url: PropTypes.string,
};

export default MultipleInputAutocomplete;
